import { ChangeDetectionStrategy, Component, Optional } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-services',
    templateUrl: './services.component.html',
    styleUrl: './services.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ServicesComponent {

    constructor(
      @Optional() public dialogRef: DialogRef) {
  
    }
  
}
